import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import "core-js/modules/es.array.concat.js";
import "regenerator-runtime/runtime.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { ApiUrl } from '../util/api.url';
import { BaseService } from './base.service';
export var InvoerService = /*#__PURE__*/function (_BaseService) {
  _inherits(InvoerService, _BaseService);
  var _super = _createSuper(InvoerService);
  function InvoerService() {
    _classCallCheck(this, InvoerService);
    return _super.apply(this, arguments);
  }
  _createClass(InvoerService, null, [{
    key: "getYearsAsync",
    value: function () {
      var _getYearsAsync = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getApiCall(this.baseUrl + 'GetAvailableYears');
            case 2:
              response = _context.sent;
              return _context.abrupt("return", response === null || response === void 0 ? void 0 : response.data);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getYearsAsync() {
        return _getYearsAsync.apply(this, arguments);
      }
      return getYearsAsync;
    }()
  }, {
    key: "getProductsByYear",
    value: function () {
      var _getProductsByYear = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(year) {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getApiCall("".concat(this.baseUrl, "GetProductsByYear?year=").concat(year));
            case 2:
              response = _context2.sent;
              return _context2.abrupt("return", response === null || response === void 0 ? void 0 : response.data);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getProductsByYear(_x) {
        return _getProductsByYear.apply(this, arguments);
      }
      return getProductsByYear;
    }()
  }, {
    key: "berekenSelectie",
    value: function () {
      var _berekenSelectie = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(request) {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.FilePostDownload(this.baseUrl + 'Bereken', request);
            case 2:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function berekenSelectie(_x2) {
        return _berekenSelectie.apply(this, arguments);
      }
      return berekenSelectie;
    }()
  }, {
    key: "getPreviewData",
    value: function () {
      var _getPreviewData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(request) {
        var response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.postApiCall(this.baseUrl + 'GetPreview', request);
            case 2:
              response = _context4.sent;
              return _context4.abrupt("return", response === null || response === void 0 ? void 0 : response.data);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getPreviewData(_x3) {
        return _getPreviewData.apply(this, arguments);
      }
      return getPreviewData;
    }()
  }]);
  return InvoerService;
}(BaseService);
InvoerService.baseUrl = ApiUrl.webapiurl() + '/Invoer/';